import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // 1. Bunu ekledik
import { getAuth } from "firebase/auth"; // 1. Burayı ekle

const firebaseConfig = {
    apiKey: "AIzaSyBK33f14h8BLxw7jyv9Gb8t6fu7MwqxLrw",
    authDomain: "takip-app-b1495.firebaseapp.com",
    projectId: "takip-app-b1495",
    storageBucket: "takip-app-b1495.firebasestorage.app",
    messagingSenderId: "1052096166044",
    appId: "1:1052096166044:web:122036fe4d7469d2f8d559",
    measurementId: "G-9Q8931JPS8"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);


// 2. Veritabanını (Firestore) başlat ve DIŞARI AKTAR (export)
export const db = getFirestore(app);
export const auth = getAuth(app); // 2. Burayı ekle